(() => {
  // Faster rendering must not allow an AJAX add to outrun Shopify's own event recorder.
  // Wait only on the platform recorder, never on Google/Meta SDKs, and do not emit extra events.
  window.LNLWaitForCartTracking = () => new Promise((resolve) => {
    const deadline = performance.now() + 8000;
    const ready = () => {
      const privacy = window.Shopify?.customerPrivacy;
      const declined = privacy?.analyticsProcessingAllowed?.() === false;
      const listener = performance.getEntriesByType('resource').some((entry) => entry.name.includes('/shop_events_listener-') && entry.responseEnd > 0);
      if (declined || (window.Shopify?.analytics?.initialized && listener) || performance.now() >= deadline) resolve();
      else setTimeout(ready, 50);
    };
    ready();
  });
  const init = () => {
    const lead = document.querySelector('[data-lnl-gallery-slide] img');
    if (!lead) return;
    let released = false;
    const release = () => {
      if (released) return;
      released = true;
      document.querySelectorAll('[data-lnl-fonts]').forEach((link) => { link.media = 'all'; });
      document.querySelectorAll('template[data-lnl-font-faces]').forEach((template) => {
        template.replaceWith(template.content.cloneNode(true));
      });
      document.querySelectorAll('[data-lnl-wallet-mount]').forEach(async (mount) => {
        try {
          const url = new URL(location.href);
          url.searchParams.set('section_id', 'lnl-speed-wallet');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Wallet section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const button = html.querySelector('.shopify-payment-button');
          if (!button) throw new Error('Wallet markup unavailable');
          const wrapper = mount.parentElement;
          mount.replaceWith(button);
          wrapper.removeAttribute('data-lnl-wallet-pending');
          wrapper.style.removeProperty('min-height');
          window.Shopify?.PaymentButton?.init();
        } catch {
          // The original Add to Bag form remains available if native wallet loading fails.
          mount.dataset.lnlWalletError = 'true';
        }
      });
      ['pointerdown', 'keydown', 'scroll'].forEach((event) => document.removeEventListener(event, release));
      lead.removeEventListener('load', release);
      lead.removeEventListener('error', release);
    };
    ['pointerdown', 'keydown', 'scroll'].forEach((event) => document.addEventListener(event, release, { once: true, passive: true }));
    if (lead.complete && lead.naturalWidth) release();
    else {
      lead.addEventListener('load', release, { once: true });
      lead.addEventListener('error', release, { once: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
